import { render, staticRenderFns } from "./Connexion.vue?vue&type=template&id=36c4bd56&"
import script from "./Connexion.vue?vue&type=script&lang=ts&"
export * from "./Connexion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports